export var isMoneyGuard = function (testObj) {
    return (testObj === null || testObj === void 0 ? void 0 : testObj.hasOwnProperty('amount')) && (testObj === null || testObj === void 0 ? void 0 : testObj.hasOwnProperty('currency'));
};
